
export default function (component: string, param?: string) {
    switch (component) {
        case "cust-cats":
            return import('../pages/profile/CategoriesPage.vue');
		case "postcode":
            return import('../pages/profile/PostcodePage.vue');
		case "region":
            return import('../pages/profile/RegionPage.vue');
		case "favorite-mail":
            return import('../pages/profile/FavoriteMailPage.vue');
		case "dynamic-attribute":
            return import('../pages/profile/DynamicAttributePage.vue');
		case "pref":
            return import('../pages/profile/PrefPage.vue');
		case "mail-account":
            return import('../pages/mail/MailAccountPage.vue');
		case "sms-account":
            return import('../pages/profile/SMSAccountPage.vue');
		case "worksheet-setting":
            return import('../pages/profile/WorksheetSettingPage.vue');
		case "loginfo":
            return import('../pages/profile/LogInfoPage.vue');
		case "merge":
            return import('../pages/agenda/MergePage.vue');
		case "bulk-changes":
            return import('../pages/agenda/BulkChangesPage.vue');
		case "integration-settings":
			return import('../pages/profile/IntegrationSettingsPage.vue');	
		case "ai-settings":
			return import('../pages/profile/AiSettingsPage.vue');
		case "bulk-consents":
			return import('../pages/agenda/BulkConsentsPage.vue');
		case "warning":
			return import('../pages/note/WarningPage.vue');
		case "send-mail":
            return import('../pages/mail/SendMailPage.vue');
		/* Row Objects */
		case "party":
			return import('../pages/addressbook/PartyPage.vue');
		case "event":
			return import('../pages/today/EventPage.vue');
		case "contact":
			return import('../pages/communication/ContactPage.vue');
		case "task":
			return import('../pages/today/TaskPage.vue');
		case "caldav-settings":
			return import('../pages/today/CalDavSettingsPage.vue');
		case "list":
			return import('../pages/profile/ListPage.vue');
		case "folder":
			return import('../pages/file/FolderPage.vue');
		case "file":
			return import('../pages/file/FilePage.vue');
		case "foldermappings":
			return import('../pages/mail/FolderMappingsPage.vue');
		case "mail-action":
			return import('../pages/mail/MailActionPage.vue');
		case "campaign":
			return import('../pages/marketing/CampaignPage.vue');
		case "campaign-party":
			return import('../pages/marketing/CampaignPartyPage.vue');
		default:
			return import('./UnknownPageComponent.vue');
    }
};